import { getDomainNameFromTeamExternalIntegration } from 'components/status-checks/status-checks-form-utils'
import { useFeatureFlags } from 'hooks/use-feature-flags'

import type {
  StatusCheckTeamExternalIntegration,
  TeamExternalIntegration
} from 'types/api/status-checks/status-check'

export function useGetStatusChecksUrls() {
  const { agentPageRedesign: isAgentPageRedesignEnabled } = useFeatureFlags()

  const statusChecksBaseUrl = isAgentPageRedesignEnabled
    ? '/configurations/health-checks'
    : '/health-checks'

  return {
    authentication: () => `${statusChecksBaseUrl}/authentication`,
    base: () => statusChecksBaseUrl,
    edit: (statusCheckId: string) =>
      `${statusChecksBaseUrl}/edit/${statusCheckId}`,
    editAuthenticationFromTeamExternalIntegration: (
      integration: TeamExternalIntegration | StatusCheckTeamExternalIntegration
    ) => {
      const domainName = getDomainNameFromTeamExternalIntegration(integration)
      return `${statusChecksBaseUrl}/edit/authentication/${integration.name}/${integration.observabilityToolType}${domainName}`
    },
    list: () => `${statusChecksBaseUrl}/list`,
    new: () => `${statusChecksBaseUrl}/new`,
    newAuthentication: () => `${statusChecksBaseUrl}/new/authentication`
  }
}
